import React, { useState, useEffect } from 'react'
import ProviderSuperbill from './ProviderSuperbill'
import { useIndexedDB } from '../../context/IndexedContext'
import SavePatients from '../../services/general/savePatientinformation.api'

const PreSignedSb = ({ noteID, patientID, patientData, signedButtonStatus, setSignedButtonStatus, setPatientModalVisible, setFilteredPatientData, superBillState, patientDBData, setPatientDBData, setShowOrderModel }) => {
  const [appointmentForthisPatient, setAppointmentForthisPatient] = useState({})
  const [isSuperbillUpdateOrSubmitted, setIsSuperbillUpdateOrSubmitted] = useState(false)

  const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [diagnosisCode, setDiagnosisCodes] = useState({})
  // const [patientDBData, setPatientDBData] = useState({})
  // const [superBillState, setSuperBillState] = useState('')
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const {
    getAllMasterDiagnosis,

    getProviderDetails,

    getAllAppointmentData,

    getPreSignedData,
  } = useIndexedDB()

  // const getProvidersMaster = async () => {
  //     // setIsPageLoading(true)
  //     try {

  //         const getProviderDetailsData = await getProviderDetails()

  //         const data = await getPreSignedData()
  //         const DBData = data[getProviderDetailsData?.ID] || []
  //         const patientWiseDBdata = DBData[patientID] || {}
  //         setPatientDBData(patientWiseDBdata)

  //         const sbStatus = await patientWiseDBdata?.newlyAddedData?.currentNote?.noteLocalStatus
  //         setSuperBillState(sbStatus)

  //         // setLoggedUserProvider(getProviderDetailsData || {})

  //     } catch (error) {
  //     } finally {
  //         // setIsPageLoading(false)
  //     }
  // }

  const getAppointmentForThisPatientScheduled = async () => {
    // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
    // const result = await PatientAppointmentDetails('GET', '', '', '', '')
    const result = await getAllAppointmentData()
    const rawData = JSON.parse(result.d)?.Data || []
    let structuredData = []

    rawData.forEach((item) => {
      let parsedList = JSON.parse(item?.AppointmentDetails)

      if (Array.isArray(parsedList)) {
        parsedList.forEach((parsedItem) => {
          const patientID = parsedItem?.patientID
          const appointmentDetails = parsedItem?.appointmentDetails || []

          const formattedAppointments = appointmentDetails.map((appointment) => {
            const data = appointment?.data || {}
            const current = appointment?.current || {
              Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
              Provider: { value: '', label: data?.ProviderName || 'Unknown' },
              Facility: { value: '', label: data?.Facility || 'Unknown' },
              Insurance: data?.Insurance || {},
              otherDetails: data?.otherDetails || {},
            }

            return { data, current }
          })

          structuredData.push({
            patientID,
            appointmentDetails: formattedAppointments,
          })
        })
      } else {
        console.warn('Unexpected non-array parsed data:', parsedList)
      }
    })

    const matchAppointment = structuredData.find((appt) => appt.patientID === patientID)

    if (!matchAppointment) return

    const allMatchedAppointmentAppointmentDetails = matchAppointment?.appointmentDetails || []

    if (allMatchedAppointmentAppointmentDetails.length === 0) return

    const MatchedAppointment = allMatchedAppointmentAppointmentDetails.find((item) => item?.data?.Status === 'Scheduled')

    setAppointmentForthisPatient(MatchedAppointment)
  }
  const [superBillForNote, setSuperBillForNote] = useState(null)

  const getSuperbillForthisnote = async () => {
    // let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientData?.PatientID.toString())
    // data = JSON.parse(data?.d)?.Data || []

    try {
      let data = patientDBData?.patientSuperBill

      if (data?.length > 0) {
        data = data.map((item) => ({
          ...item,
          JsonData: item?.JsonData ? JSON.parse(item.JsonData) : {},
        }))
      }

      const findBillForThisNote = data?.find((item) => item?.JsonData?.noteID === noteID)

      if (findBillForThisNote?.JsonData?.patientSeen) {
        setSuperBillForNote(findBillForThisNote)
      }

      // setSuperBillForNote(findBillForThisNote)
    } catch (error) {
      console.error('super bill error', error)
    }
  }

  const fetchDiagnosisMaster = async () => {
    let formattedDataDiagnosis
    // formattedDataDiagnosis = await GetDiagnosisData()
    const getAllMasterDiagnosiss = await getAllMasterDiagnosis()
    let allDiagnosisCodes = {}
    if (getAllMasterDiagnosiss) {
      formattedDataDiagnosis = getAllMasterDiagnosiss?.Data
      for (const diagnosis of formattedDataDiagnosis) {
        allDiagnosisCodes[diagnosis.Name.trim()] = diagnosis.Code
      }
    }
    setDiagnosisCodes(allDiagnosisCodes)
  }
  useEffect(() => {
    getAppointmentForThisPatientScheduled()
    fetchDiagnosisMaster()
  }, [])

  // useEffect(()=>{
  //     getProvidersMaster()
  // }, [patientID])
  return (
    <>
      {Object.keys(patientDBData).length > 0 && (
        <ProviderSuperbill
          getAppointmentForThisPatientScheduled={getAppointmentForThisPatientScheduled}
          getSuperbillForthisnote={getSuperbillForthisnote}
          viewPatientDetail={patientData}
          noteID={noteID}
          patientDiagnosis={patientDiagnosis}
          diagnosisCode={diagnosisCode}
          patientDBData={patientDBData}
          setPatientDBData={setPatientDBData}
          setIsSuperbillUpdateOrSubmitted={setIsSuperbillUpdateOrSubmitted}
          superBillState={superBillState}
          setSignedButtonStatus={setSignedButtonStatus}
          signedButtonStatus={signedButtonStatus}
          setPatientModalVisible={setPatientModalVisible}
          setFilteredPatientData={setFilteredPatientData}
          setShowOrderModel={setShowOrderModel}
          // noteCallType={noteCallType}
        />
      )}
    </>
  )
}

export default PreSignedSb
